module.exports = __webpack_public_path__ + "wedding_love_1.jpg";